<template lang="html">
  <div class="Footer">
    <p>
      2020, <a href="http://www.clipleap.com">ClipLeap</a>
      by <a href="http://www.efojs.com">EFOJS</a>
    </p>
    <p>
      <router-link to="/terms" v-if="$route.name!='terms'">Terms of Service</router-link>
      <span v-else>Terms of Service</span>
      and
      <router-link to="/rules" v-if="$route.name!='rules'">Rules</router-link>
      <span v-else>Rules</span>
    </p>
    <p>
      <router-link to="/privacy" v-if="$route.name!='privacy'">Privacy Policy</router-link>
      <span v-else>Privacy Policy</span>
    </p>
    <p>
      <router-link to="/cookies" v-if="$route.name!='cookies'">Cookie Policy</router-link>
      <span v-else>Cookie Policy</span>
    </p>
    <p>
      <router-link to="/about" v-if="$route.name!='about'">About</router-link>
      <span v-else>About</span>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Footer',
  props: [],
  components: {
  },

  methods: {

  },

  data: function() {
    return {
    }
  },

  computed: {
    ...mapGetters([
    ]),
  }
}
</script>

<style lang="css" scoped>
.Footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #000;
  margin: 4rem -3rem 0;
  padding: 1.5rem 6rem;
  color: rgb(97, 132, 148);
  font-size: 90%;
}
p {
  margin: 0;
}
p a {
  color: rgb(97, 132, 148);
}
p a:hover {
  color: rgb(161, 10, 10);
}
span {
  font-weight: bold;
}
</style>
